function encodeString(str) {
  return str
    .split("")
    .map((char) => {
      switch (char) {
        case " ":
          return "+";
        case "!":
          return "%21";
        case "#":
          return "%23";
        case "$":
          return "%24";
        case "&":
          return "%26";
        case "'":
          return "%27";
        case "(":
          return "%28";
        case ")":
          return "%29";
        case "*":
          return "%2A";
        case "+":
          return "%2B";
        case ",":
          return "%2C";
        case "/":
          return "%2F";
        case ":":
          return "%3A";
        case ";":
          return "%3B";
        case "=":
          return "%3D";
        case "?":
          return "%3F";
        case "@":
          return "%40";
        case "[":
          return "%5B";
        case "]":
          return "%5D";
        default:
          return char;
      }
    })
    .join("");
}

const manufacturers = window.manufacturers;
const models = window.models;
const trims = window.trims;

const manufacturersSelect = document.querySelector(".js-manufacturers");
const modelsSelect = document.querySelector(".js-model");
const trimSelect = document.querySelector(".js-trim");
const genericSubmitButton = document.querySelector(
  ".js-filters__submit--generic"
);
const bikesSubmitButton = document.querySelector(".js-filters__submit--bikes");

modelsSelect.disabled = true;
trimSelect.disabled = true;
genericSubmitButton.classList.add("disable");

manufacturers.forEach((item) => {
  const option = document.createElement("option");
  option.text = item.hersteller_name;
  option.value = item.hersteller_id;
  manufacturersSelect.appendChild(option);
});

manufacturersSelect.addEventListener("change", function () {
  const selectedManufacturer = this.value;
  // remove all options except the label
  while (modelsSelect.options.length > 1) {
    modelsSelect.remove(1);
  }
  // remove old trim options
  while (trimSelect.options.length > 1) {
    trimSelect.remove(1);
  }
  if (selectedManufacturer !== "") {
    // populate models select with options from models object
    models[selectedManufacturer].forEach((model) => {
      const option = document.createElement("option");
      option.text = model.modell_name;
      option.value = model.modell_id;
      modelsSelect.appendChild(option);
    });

    modelsSelect.disabled = false;
  } else {
    modelsSelect.disabled = true;
  }
  !genericSubmitButton.classList.contains("disable") &&
    genericSubmitButton.classList.add("disable");

  trimSelect.disabled = true;
});

modelsSelect.addEventListener("change", function () {
  const selectedModel = this.value;

  // remove all options except the label
  while (trimSelect.options.length > 1) {
    trimSelect.remove(1);
  }

  if (selectedModel !== "") {
    // populate trim select with options from trims object
    trims[selectedModel].forEach((trim) => {
      const option = document.createElement("option");
      option.text = trim.ausfuehrung_name;
      option.value = trim.ausfuehrung_name;
      trimSelect.appendChild(option);
    });

    trimSelect.disabled = false;
  } else {
    trimSelect.disabled = true;
    !genericSubmitButton.classList.contains("disable") &&
      genericSubmitButton.classList.add("disable");
  }
});

trimSelect.addEventListener("change", function () {
  const selectedTrim = this.value;
  if (selectedTrim !== "") {
    genericSubmitButton.classList.contains("disable") &&
      genericSubmitButton.classList.remove("disable");
  } else {
    !genericSubmitButton.classList.contains("disable") &&
      genericSubmitButton.classList.add("disable");
  }
});

genericSubmitButton.addEventListener("click", (e) => {
  e.preventDefault();
  const manufacturerFilter = encodeString(
    manufacturersSelect.options[manufacturersSelect.selectedIndex].textContent
  );
  const modelFilter = encodeString(
    modelsSelect.options[modelsSelect.selectedIndex].textContent
  );
  const trimFilter = encodeString(
    trimSelect.options[trimSelect.selectedIndex].textContent
  );
  const newLink = `/collections/grundtraeger-basistraeger-lastentraeger?filter.p.m.custom.manufacturer=${manufacturerFilter}&filter.p.m.custom.model=${modelFilter}&filter.p.m.custom.trim=${trimFilter}`;
  window.location.href = newLink;
  manufacturersSelect.value = "";
});

bikesSubmitButton.addEventListener("click", (e) => {
  e.preventDefault();
  const bikesCount = document.querySelector(".js-bikesCount").value.trim();
  const bikeTypes = document.querySelector(".js-bikeTypes");
  const ebike = document.querySelector(".js-ebike").value.trim();
  const carbon = document.querySelector(".js-carbon").value.trim();
  const tailgate = document.querySelector(".js-tailgate").value.trim();
  const wingDoors = document.querySelector(".js-wingDoors").value.trim();

  let bikeTypesQuery = window.bikeTypes;
  if (bikeTypesQuery === "&") bikeTypesQuery = "";

  const newLink = `/collections/fahrradtrager-anhangerkupplung?filter.p.m.custom.number_of_bikes=${bikesCount}${bikeTypesQuery}&filter.p.m.custom.e_bike=${ebike}&filter.p.m.custom.suitable_for_carbon=${carbon}&filter.p.m.custom.suitable_for_heckklappe=${tailgate}&filter.p.m.custom.suitable_for_wing_doors=${wingDoors}`;
  window.location.href = newLink;
  manufacturersSelect.value = "";
});
